import { Form } from 'components/form'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import { useAuth } from 'contexts/auth'
import { useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import PreviewTheme from './logo-and-colors-preview'

const ThemePreviewForm = () => {
  const { user } = useAuth()
  const history = useHistory()

  const onSubmit = useCallback(async (data: any) => {}, [history])

  useEffect(() => {
    if (user && !user.isSeller) {
      history.push('/')
    }
  }, [user])

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title
          text='Personalize sua Conta'
          actionRoute='/themes/edit'
          actionText='Personalize sua conta'
        />
      </Header>
      <Page>
        <Form.Root onHandleSubmit={onSubmit}>
          <Form.Body>
            <PreviewTheme />
          </Form.Body>

          <Form.Divisor />
        </Form.Root>
      </Page>
    </Wrapper>
  )
}

export default ThemePreviewForm
